module.exports = __webpack_public_path__ + "static/kleros-conference-1-5071f2ff80d5d9a530c53dd4fe8e405c.jpg";